import {LinearChart} from "./LinearChart";
import {TaskSearch} from "./taskSearch.model";

export class ReferralChart {
  constructor(

    public referralData?: any[],
    public referralChartDateFrom?: any,
    public referralChartDateTo ?: any,

    public refCounty ?: String,


  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/ReferralChart.ts